import { render, staticRenderFns } from "./CmgCelebrateAchievementModal.vue?vue&type=template&id=c23a7978&scoped=true&lang=pug&"
import script from "./cmg-celebrate-achievement-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-celebrate-achievement-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCelebrateAchievementModal.vue?vue&type=style&index=0&id=c23a7978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a7978",
  null
  
)

export default component.exports